export default __webpack_public_path__ + "static/media/kelvin.e8a34e72.jpeg";